import React, { useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import Certificate from './Certificate';

const UploadCertificates = () => {
  const navigate = useNavigate();

  const [backgroundImage, setBackgroundImage] = useState(null);
  const [logoImage, setLogoImage] = useState(null);
  const [studentPhoto, setStudentPhoto] = useState(null);
  const [topMarginFrame, setTopMarginFrame] = useState(50);
  const [students, setStudents] = useState([]);
  const certificateRefs = useRef();

  const handleBackgroundUpload = (e) => {
    const file = e.target.files[0];
    if (file) setBackgroundImage(URL.createObjectURL(file));
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) setLogoImage(URL.createObjectURL(file));
  };

  const handleStudentUpload = (e) => {
    const file = e.target.files[0];
    if (file) setStudentPhoto(URL.createObjectURL(file));
  };

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet);
      setStudents(rows);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleGenerate = () => {
    if (!students.length) return alert('Upload Excel first!');
    navigate('/generate-certificate', {
      state: {
        backgroundImage,
        logoImage,
        studentPhoto,
        topMarginFrame,
        students,
      },
    });
  };

  return (
    <div className="container my-3">
      <h2>Upload Certificate Assets & Student List</h2>

      <div className="mb-3">
        <label>Background Image:</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleBackgroundUpload}
          className="form-control"
        />
      </div>

      <div className="mb-3">
        <label>Logo Image:</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleLogoUpload}
          className="form-control"
        />
      </div>

      <div className="mb-3">
        <label>Default Student Photo:</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleStudentUpload}
          className="form-control"
        />
      </div>

      <div className="mb-3">
        <label>Top Margin:</label>
        <input
          type="number"
          value={topMarginFrame}
          onChange={(e) => setTopMarginFrame(Number(e.target.value))}
          className="form-control"
        />
      </div>

      <div className="mb-3">
        <label>Upload Student Excel (.xlsx):</label>
        <input
          type="file"
          accept=".xlsx,.xls"
          onChange={handleExcelUpload}
          className="form-control"
        />
      </div>

      <button className="btn btn-primary" onClick={handleGenerate}>
        Generate Certificates
      </button>

      <h1>Preview</h1>
      <div className="">
        {backgroundImage &&
          logoImage &&
          topMarginFrame &&
          students &&
          students.length > 0 && (
            <Certificate
              key={1}
              ref={certificateRefs}
              student={students[0]}
              backgroundImage={backgroundImage}
              logoImage={logoImage}
              studentPhoto={studentPhoto}
              topMarginFrame={topMarginFrame}
            />
          )}{' '}
      </div>
    </div>
  );
};

export default UploadCertificates;
